export type SortDirection = 'ASC' | 'DESC';

export type SortOption = {
  label: string;
  value: string;
  isDefault?: boolean;
  leadOnly?: boolean;
};

export const SORT_DIRECTION_OPTIONS: { label: string; value: SortDirection }[] = [
  { label: 'Descending', value: 'DESC' },
  { label: 'Ascending', value: 'ASC' },
];

export const LEADS_DASHBOARD_SORT_OPTIONS: SortOption[] = [
  { label: 'Fit Score', value: 'fitScore', leadOnly: true },
  { label: 'Engagement Score', value: 'engagementScore', leadOnly: true },
  { label: 'Fit & Engagement Score', value: 'compositeScore', isDefault: true, leadOnly: true },
  { label: 'Last Email', value: 'lastEmailDate' },
  { label: 'Last Call', value: 'lastCallDate' },
  { label: 'Last Text', value: 'lastTextDate' },
];

export const getSortOptions = (isLeadDashboard: boolean) =>
  LEADS_DASHBOARD_SORT_OPTIONS.filter(
    option => isLeadDashboard || !option.leadOnly
  );

export const getDefaultSortBy = (options: SortOption[]) =>
  (options.find(option => option.isDefault) ?? options[0]).value;

export const DEFAULT_SORT_BY = getDefaultSortBy(LEADS_DASHBOARD_SORT_OPTIONS);
export const DEFAULT_SORT_DIR: SortDirection = 'DESC';
